import React from 'react';
import PropTypes from 'prop-types';
import GalleryItem from './GalleryItem';

const GalleryGrid = ({ items, onOpenModal }) => {
  return (
    <div className="gallery-grid">
      {items.map((item, index) => (
        <GalleryItem
          key={index}
          item={item}
          index={index}
          onOpenModal={onOpenModal}
        />
      ))}
    </div>
  );
};

GalleryGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      ratio: PropTypes.string.isRequired,
      prompt: PropTypes.string.isRequired,
    })
  ).isRequired,
  onOpenModal: PropTypes.func.isRequired,
};

export default GalleryGrid;